import { render, staticRenderFns } from "./GuangzhouUnicom6.vue?vue&type=template&id=4abadff7&scoped=true"
import script from "./GuangzhouUnicom6.vue?vue&type=script&lang=js"
export * from "./GuangzhouUnicom6.vue?vue&type=script&lang=js"
import style0 from "./GuangzhouUnicom6.vue?vue&type=style&index=0&id=4abadff7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abadff7",
  null
  
)

export default component.exports